const unique = (values: readonly string[]): readonly string[] => [...new Set(values)];

export const collectUnavailableInclusionValues = <T>(
    conditions: readonly T[],
    selected: T | null,
    isSameCondition: (left: T, right: T) => boolean,
    projectValues: (condition: T) => readonly string[],
): readonly string[] => {
    const unavailable: string[] = [];

    for (const condition of conditions) {
        if (selected !== null && isSameCondition(condition, selected)) {
            continue;
        }

        unavailable.push(...projectValues(condition));
    }

    return unique(unavailable);
};
